import { map } from 'ramda';

import { renameFoundObjectProperties } from '../utils/formatters';

export type Sound = '' | 'alarm' | 'droplet' | 'glass' | 'morsecode' | 'opencan' | 'pot' | 'shatter' | 'siren';

export type TID = string;
export type VID = string;
export type CategoryId = string;

export interface RelevantCategory {
  depth: number;
  description: string;
  id: CategoryId;
  name: string;
  parents: number[];
  tid: number;
  vid: number;
  weight: string;
}

export interface CategoriesResponse {
  pr_types: string[];
  taxonomies: TaxonomiesById;
  terms: RelevantCategoriesById;
  types: Type[];
}

export interface TaxonomiesById {
  [id: string]: Taxonomy;
}

export interface RelevantCategoriesById {
  [id: string]: RelevantCategory[];
}

export interface TaxonomyNode {
  associatedpress: string;
  bzsignals: string;
  globenewswire_story: string;
  jijipress: string;
  marketwire_story: string;
  podcast: string;
  pr_forexlive: string;
  story: string;
  tickertech: string;
}

export interface Taxonomy {
  description: string;
  help: string;
  hierarchy: string;
  module: string;
  multiple: string;
  name: string;
  nodes: TaxonomyNode[];
  relations: string;
  required: string;
  tags: string;
  vid: VID;
  weight: string;
}

export interface Type {
  description: string;
  full_name: string;
  name: string;
  short_name: string;
  type: string;
}

// Deprecated. It may be removed in future release.
export interface IncomingCategory {
  // aka "channel"
  channel_description: string;
  channel_id: string;
  channel_name: string;
  // TODO: 'email' | ???
  sound: Sound;
  subscription_type: string;
  tids: number[];
}

export interface Category {
  description: string;
  id: CategoryId;
  name: string;
  realtimeEmails: boolean;
  sound: Sound;
  tid: number;
  tids: number[];
  vid: number;
}

// Deprecated. It may be removed in future release.
export type CategoriesById = {
  [categoryId in CategoryId]: Category;
};

// Deprecated. It may be removed in future release.
export interface Categories {
  categoriesById: CategoriesById;
  categoryIds: CategoryId[];
  isFetching: boolean;
}

export interface RelevantCategories {
  categories: StoredRelevantCategory[];
  categoriesById: RelevantCategoryById;
  isFetching: boolean;
}

export type RelevantCategoryById = {
  [id in CategoryId]: RelevantCategory;
};

export interface StoredRelevantCategory extends RelevantCategory {
  children: RelevantCategory[];
}

// Deprecated. It may be removed in future release.
export type IncomingCategoriesById = {
  [categoryId in CategoryId]: IncomingCategory;
};

const categoryBeforeAndAfter = {
  channel_description: 'description',
  channel_id: 'id',
  channel_name: 'name',
  sound: 'sound',
  subscription_type: {
    after: 'realtimeEmails',
    transform: Boolean,
  },
  tids: {
    after: 'tids',
    transform: (tids: { tid: string }[]) => map((tid: { tid: string }) => parseInt(tid.tid, 10), tids),
  },
};

export const ingestCategory = renameFoundObjectProperties<IncomingCategory, Category>(categoryBeforeAndAfter);
